import { createTheme } from '@material-ui/core/styles';
import { palette } from './colors';

const theme = createTheme({
  typography: {
    fontFamily: ['Roboto', 'sans-serif'].join(','),
  },
  palette: {
    ...palette,
  },
  overrides: {
    MuiTabs: {
      indicator: {
        backgroundColor: palette.tabs.indicator,
        height: '3px',
        minWidth: 'unset !important',
      },
      root: {
        minHeight: 'unset',
        height: '32px',
        backgroundColor: '#FFF',
        borderBottom: 0,
      },
    },
    MuiTab: {
      root: {
        textTransform: 'none',
        minWidth: 'unset !important',
        minHeight: 'unset',
        height: '32px',
        marginRight: '32px',
        padding: '8px',
        color: '#BAC0D0',
        fontWeight: 400,
        fontSize: '1rem',
        '&$selected': {
          color: '#1891F6',
          fontWeight: 700,
        },
      },
      textColorInherit: {
        color: '#BAC0D0',
      },
    },
    MuiListItemIcon: {
      root: {
        minWidth: '30px',
      },
    },
    MuiSnackbarContent: {
      root: {
        padding: 0,
      },
      action: {
        paddingLeft: 0,
      },
    },
    MuiDataGrid: {
      root: {
        border: 'none',
        '& .MuiDataGrid-windowContainer': {
          height: '480px !important',
        },
        '& .MuiDataGrid-columnSeparator': {
          display: 'none',
        },
        color: '#000',
        fontSize: '0.875rem',
        '&.MuiDataGrid-root .MuiDataGrid-cell': {
          lineHeight: 'unset !important',
          minHeight: 'unset !important',
        },
        '&.MuiDataGrid-root .MuiDataGrid-cell:focus': {
          outline: 'none',
        },
        '&.MuiDataGrid-root .MuiDataGrid-columnHeader': {
          paddingLeft: '5px',
          textAlign: 'left',
        },
        '&.MuiDataGrid-root .MuiDataGrid-columnHeader:focus': {
          outline: 'none',
        },
        '&.MuiDataGrid-root .MuiDataGrid-columnHeader:focus-within': {
          outline: 'none',
        },
        '&.MuiDataGrid-root .MuiDataGrid-row': {
          height: '40px',
          minHeight: 'unset !important',
          backgroundColor: '#FFF',
          marginBottom: '4px',
          borderRadius: '4px',
        },
      },
    },
    MuiPaper: {
      elevation1: {
        boxShadow: 'none',
      },
    },
    MuiSvgIcon: {
      root: {
        fontSize: '1.2rem',
      },
    },
    MuiAlert: {
      message: {
        maxHeight: '80vh',
        textAlign: 'left',
        overflowY: 'auto',
      },
    },
    MuiButton: {
      startIcon: {
        marginRight: '4px',
        '& .MuiSvgIcon-root': {
          width: '0.8em !important',
          height: '0.8em !important',
        },
      },
    },
    MuiDialogTitle: {
      root: {
        fontSize: '1rem',
        fontWeight: 700,
        display: 'flex',
        alignItems: 'center',
        padding: '16px 0 8px 24px',
        '& svg': {
          width: '1.6rem',
          height: '1.6rem',
          marginRight: '5px',
        },
      },
    },
    MuiDialogContent: {
      root: {
        padding: '0 25px !important',
      },
    },
    MuiDialogActions: {
      root: {
        justifyContent: 'center',
        padding: '20px 25px',
      },
    },
    MuiAccordion: {
      root: {
        '&::before': {
          height: 0,
        },
        '&.Mui-expanded': {
          margin: 0,
        },
      },
    },
    MuiAccordionSummary: {
      root: {
        minHeight: 'unset !important',
        margin: '0 !important',
        '&.Mui-expanded': {
          minHeight: 'unset !important',
          margin: '0 !important',
        },
      },
      content: {
        margin: 0,
      },
    },
    MuiCheckbox: {
      root: {
        padding: '0 8px',
        '&$checked': {
          color: '#1891F6 !important',
        },
      },
    },
    MuiLinearProgress: {
      root: {
        backgroundColor: 'unset !important',
      },
    },
  },
});

export default theme;
